/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type MissionControlDeactivateSageIntacctInput = {
    companyId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type MissionControlDeactivateSageIntacctMutationVariables = {
    input: MissionControlDeactivateSageIntacctInput;
};
export type MissionControlDeactivateSageIntacctMutationResponse = {
    readonly missionControlDeactivateSageIntacct: {
        readonly outcome: string | null;
        readonly errorMessage: string | null;
    } | null;
};
export type MissionControlDeactivateSageIntacctMutation = {
    readonly response: MissionControlDeactivateSageIntacctMutationResponse;
    readonly variables: MissionControlDeactivateSageIntacctMutationVariables;
};



/*
mutation MissionControlDeactivateSageIntacctMutation(
  $input: MissionControlDeactivateSageIntacctInput!
) {
  missionControlDeactivateSageIntacct(input: $input) {
    outcome
    errorMessage
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "MissionControlDeactivateSageIntacctInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MissionControlDeactivateSageIntacctPayload",
    "kind": "LinkedField",
    "name": "missionControlDeactivateSageIntacct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MissionControlDeactivateSageIntacctMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MissionControlDeactivateSageIntacctMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MissionControlDeactivateSageIntacctMutation",
    "operationKind": "mutation",
    "text": "mutation MissionControlDeactivateSageIntacctMutation(\n  $input: MissionControlDeactivateSageIntacctInput!\n) {\n  missionControlDeactivateSageIntacct(input: $input) {\n    outcome\n    errorMessage\n  }\n}\n"
  }
};
})();
(node as any).hash = '7e822f76af3be76bfbd33941e7cc0e95';
export default node;
